﻿import {
 fetchBaseQueryWrapper,
 NO_CACHING,
} from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

const TAG_TYPES = {
 ctqSnapshot: "CtqSnapshot",
 testPlans: "CTQ Test Plans",
};

export const ctqSnapshotApi = createApi({
 reducerPath: "ctqSnapshotApi",
 baseQuery: fetchBaseQueryWrapper({
  path: "projects",
 }),
 tagTypes: [TAG_TYPES.ctqSnapshot, TAG_TYPES.testPlans],
 keepUnusedDataFor: NO_CACHING,
 endpoints: (build) => ({
  getTestPlans: build.query({
   query: ({ routeParams: { projectId } }) => ({
    url: `${projectId}/ctq/test-plans`,
    method: 'GET'
   }),
   transformResponse: (response) => response.data,
   providesTags: (_result, _error, { routeParams: { projectId } }) => [
    { type: TAG_TYPES.testPlans, id: projectId },
   ],
  }),
  getCTQSnapshot: build.query({
   query: ({ routeParams: { projectId, milestoneId } }) => ({
    url: `${projectId}/milestone/${milestoneId}/getSnapshots`,
    method: 'GET'
    }),
   transformResponse: (response) => response.data,
   providesTags: (result, error, { routeParams: { milestoneId } }) => [{ type: TAG_TYPES.ctqSnapshot, id: milestoneId }]
  }),
  createCTQSnapshot: build.mutation({
   query: ({ routeParams: { projectId, milestoneId }, body }) => ({
    url: `${projectId}/milestone/${milestoneId}/addCtqSnapshot`,
    method: 'POST',
    body: body
   }),
   invalidatesTags: (result, error, { routeParams: { milestoneId } }) => [{ type: TAG_TYPES.ctqSnapshot, id: milestoneId }]
  }),
  deleteCTQSnapshot: build.mutation({
   query: ({ routeParams: { projectId, milestoneId, snapshotId } }) => ({
    url: `${projectId}/milestone/${milestoneId}/deleteCtqSnapshot/${snapshotId}`,
    method: 'DELETE'
   }),
   invalidatesTags: (result, error, { routeParams: { milestoneId } }) => [{ type: TAG_TYPES.ctqSnapshot, id: milestoneId }]
  })
 }),
});

export const {
 useLazyGetTestPlansQuery,
 useGetCTQSnapshotQuery,
 useCreateCTQSnapshotMutation,
 useDeleteCTQSnapshotMutation,
} = ctqSnapshotApi;
